// frontend/src/services/auth.js
export function logout() {
  localStorage.removeItem('token')
  localStorage.removeItem('userData')
  window.location.href = '/login'
}